import type { GlobalFilter } from '@hotjar/global-filters';
import {
  MAX_DATA_RETENTION_PERIOD,
  START_DATE_OF_QUANTZ_DATA_COLLECTION,
  StatefulFilterChain,
} from '@hotjar/webapp/features/GlobalFilterChain/StatefulComponent/StatefulFilterChain';
import styled from '@emotion/styled';
import { ProductType } from '@hotjar/webapp/domains/common/product/types';
import type { PlanComparisonReferrer } from '@hotjar/webapp/features/Billing/PlanComparisonModal/types';
import type { AdditionalTrackingData } from '@hotjar/dashboard-quantz';
import { TRENDS_AND_FUNNELS_SUPPORTED_FILTER_LIST } from './MultiFilterChain/OneFilterChain';

const Container = styled.div`
  display: flex;
`;

export type FunnelsDateRangeProps = {
  currentFiltersInUiFormat: GlobalFilter;
  onFiltersChange: (filtersInUiFormat: GlobalFilter, segmentId?: number) => void;
  onUpsellRequest: (
    featureName: PlanComparisonReferrer,
    additionalTrackingData?: AdditionalTrackingData,
  ) => void;
};

export const FunnelsDateRange = ({
  currentFiltersInUiFormat,
  onFiltersChange,
  onUpsellRequest,
}: FunnelsDateRangeProps): JSX.Element => {
  return (
    <Container>
      <StatefulFilterChain
        currentFiltersInUiFormat={currentFiltersInUiFormat}
        onChange={onFiltersChange}
        onUpsellRequest={(featureName, kind) =>
          onUpsellRequest(featureName as PlanComparisonReferrer, {
            ui_position: `funnels.filters.${kind}`,
          })
        }
        hideSaveSegment
        hideAllFilters
        useToggleGroupDatePicker
        supportedFilterList={TRENDS_AND_FUNNELS_SUPPORTED_FILTER_LIST}
        dateConstraint={
          MAX_DATA_RETENTION_PERIOD.minDate < START_DATE_OF_QUANTZ_DATA_COLLECTION.minDate
            ? START_DATE_OF_QUANTZ_DATA_COLLECTION
            : MAX_DATA_RETENTION_PERIOD
        }
        contextOfUse={{
          productType: ProductType.Analytics,
          page: 'funnels',
          toolName: 'Funnels',
        }}
      />
    </Container>
  );
};
